import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Thankyou.css";

function Thankyou() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleExploreClick = () => {
    const redirectPath = new URLSearchParams(location.search).get("redirect");
    const decodedRedirectPath = redirectPath
      ? decodeURIComponent(redirectPath)
      : null;
    navigate(decodedRedirectPath || "/");
  };

  return (
    <div className="thankyou-container">
      <div className="thankyou-content">
        <h1 className="thankyou-title">Thank you for Subscribing!</h1>
        <p className="thankyou-message">
          Welcome to premium! You now have access to unlimited searches.
        </p>
        <button className="explore-button" onClick={handleExploreClick}>
          Explore Unlimited Searches
        </button>
      </div>
    </div>
  );
}

export default Thankyou;
